
<footer class="footer">
  <!-- Footer Frame -->
  <div class="footer--frame">
    <div class="footer--frame-wrapper">
      <img [src]="footerFrameIcon" alt="Footer decorative frame" class="footer--frame-image" />
    </div>
  </div>
  
  <div class="footer--container">
    <div class="footer--content">
      <!-- About Section -->
      <div class="footer--section footer--about">
        <h3 class="footer--title">Maharashtra Agriculture Data Exchange (MahaAgX)</h3>
        <p class="footer--description">
          MahaAgX is a platform that helps revolutionise agriculture through a secure data exchange network for researchers, innovators, and policymakers.
        </p>
        
        <div class="footer--contact">
          <div class="contact--item">
            <img [src]="globalIcon" alt="Website" class="contact--icon" />
            <a [href]="catalogueUiUrl" target="_blank" rel="noopener noreferrer">{{ catalogueUiUrl }}</a>
          </div>
        </div>
      </div>

      <!-- Important Links -->
      <div class="footer--section footer--links">
        <h3 class="footer--section-title">Important links</h3>
        <ul class="footer--link-list">
          <li *ngFor="let link of importantLinks">
            <a
              *ngIf="!link.external && link.requiresAuth"
              href="#"
              (click)="onAuthGatedLinkClick($event, link)"
              class="footer--link">{{ link.label }}</a>
            <a
              *ngIf="!link.external && !link.requiresAuth && link.url"
              [routerLink]="link.url"
              class="footer--link">{{ link.label }}</a>
            <a *ngIf="link.external" [href]="link.url" target="_blank" rel="noopener noreferrer" class="footer--link">{{ link.label }}</a>
          </li>
        </ul>
      </div>

      <!-- Developer Links -->
      <div class="footer--section footer--developers">
        <h3 class="footer--section-title">For Developers</h3>
        <ul class="footer--link-list">
          <li *ngFor="let link of developerLinks">
            <a [href]="link.url" target="_blank" rel="noopener noreferrer" class="footer--link">{{ link.label }}</a>
          </li>
        </ul>
      </div>

      <!-- Initiative & Partner logos -->
      <div class="footer--section footer--logos">
        <div class="footer--initiative-block">
          <h3 class="footer--section-title">Initiative By</h3>
          <div class="footer--initiative-logos">
            <a
              *ngFor="let logo of initiativeLogos"
              [href]="logo.url"
              target="_blank"
              rel="noopener noreferrer"
              class="footer--initiative-logo-item"
              [attr.aria-label]="logo.name"
            >
              <img
                [src]="logo.src"
                [alt]="logo.name"
                class="footer--initiative-logo-img"
                [class.footer--initiative-logo-img-color]="logo.useFilter === false"
                loading="lazy"
                (error)="onLogoError($event)"
              />
            </a>
          </div>
        </div>
        <div class="footer--partners-block">
          <h3 class="footer--section-title">Partners</h3>
          <div class="footer--logo-list">
            <a *ngFor="let logo of partnerLogos" [href]="logo.url" target="_blank" rel="noopener noreferrer" class="footer--logo-item" [attr.aria-label]="logo.name">
              <img [src]="logo.src" [alt]="logo.name" class="footer--logo-img" loading="lazy" (error)="onLogoError($event)" />
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- Copyright -->
    <div class="footer--bottom">
      <p class="footer--copyright">
        © {{ currentYear }} by MahaAgX
        <span class="footer--legal-links">
          <a [routerLink]="['/privacy-policy']" class="footer--legal-link">Privacy Policy</a>
          <span class="footer--separator">|</span>
          <a [routerLink]="['/terms-of-service']" class="footer--legal-link">Terms of Service</a>
        </span>
      </p>
    </div>
  </div>
</footer>

<app-login-modal
  *ngIf="showLoginModal"
  [redirectUri]="loginRedirectUri"
  (visibleChange)="showLoginModal = $event"
></app-login-modal>


